import { render, staticRenderFns } from "./MemberProfileHeader.vue?vue&type=template&id=5b2ae7a8&scoped=true&"
import script from "./MemberProfileHeader.vue?vue&type=script&lang=js&"
export * from "./MemberProfileHeader.vue?vue&type=script&lang=js&"
import style0 from "./MemberProfileHeader.vue?vue&type=style&index=0&id=5b2ae7a8&lang=scss&scoped=true&"
import style1 from "./MemberProfileHeader.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2ae7a8",
  null
  
)

export default component.exports